import { ISODateString } from 'models/misc'

/** 4-step card status computed server-side (ISSUE-2015). CANCELLED renders no card. */
export enum PropertyOrderStatusStep {
  ORDER_PLACED = 'ORDER_PLACED',
  APPOINTMENT_AGREED = 'APPOINTMENT_AGREED',
  POST_PRODUCTION = 'POST_PRODUCTION',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED',
}

/** Accepted photographer contact, exposed only once a creative accepted the assignment. */
export interface PhotographerContactDTO {
  name: string
  phone: string | null
}

/** One status card per order on a property (ISSUE-2015 endpoint response item). */
export interface RealEstatePropertyOrderStatusDTO {
  orderId: number
  statusStep: PropertyOrderStatusStep
  createdAt: ISODateString
  shootingStartDateTime: ISODateString | null
  photographer: PhotographerContactDTO | null
}
